import { useFlags } from "launchdarkly-react-client-sdk";
import { RevAvatar, RevLink, RevWhiteDisclosure } from "@revmatics/catalyst";
import { fullFormatNumbers } from "../../../../../../helpers/functions/formatNumber.ts";
import { useAppSelector } from "../../../../../../stores/hooks/hooks.ts";

export const PersonaOverview = () => {
  const { personaDetails: ffPersonaDetails } = useFlags();
  const selectedPersona = useAppSelector(
    (state) => state.discoverCommunities.selectedPersona,
  );
  if (selectedPersona) {
    return (
      <RevWhiteDisclosure title="Buyer Persona Overview">
        <div className="w-full bg-white p-4 grid grid-cols-1 lg:grid-cols-3 gap-4">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4">
              <RevAvatar
                variant="circle"
                size="large"
                theme="light"
                image={
                  selectedPersona.persona_picture ||
                  selectedPersona.persona_picture_url ||
                  undefined
                }
                firstName={selectedPersona.name.split(" ")[0]}
                lastName={selectedPersona.name.split(" ").pop()}
                gender={selectedPersona.gender}
              />
              {ffPersonaDetails ? (
                <RevLink
                  pathname=""
                  search={`personaId=${selectedPersona.id}`}
                  text={selectedPersona.name}
                  linkFontSize="largeBold"
                  underline={false}
                />
              ) : (
                <span className="typography-body-sm">
                  {selectedPersona.name}
                </span>
              )}
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-1 flex-wrap">
                <p className="typography-body-sm text-monochrome-500 text-nowrap">
                  Age Range:
                </p>
                <p className="typography-body-sm text-monochrome-900">
                  {selectedPersona.age_to && selectedPersona.age_from
                    ? `${selectedPersona.age_from} - ${selectedPersona.age_to}`
                    : "-"}
                </p>
              </div>
              <div className="flex items-center gap-1 flex-wrap">
                <p className="typography-body-sm text-monochrome-500 text-nowrap">
                  Gender:
                </p>
                <p className="typography-body-sm text-monochrome-900">
                  {selectedPersona.gender || "-"}
                </p>
              </div>
              <div className="flex items-center gap-1 flex-wrap">
                <p className="typography-body-sm text-monochrome-500 text-nowrap">
                  Income:
                </p>
                <p className="typography-body-sm text-monochrome-900">
                  {selectedPersona.income_from && selectedPersona.income_to
                    ? `$${fullFormatNumbers({ value: selectedPersona.income_from })} - $${fullFormatNumbers({ value: selectedPersona.income_to })}`
                    : "-"}
                </p>
              </div>
              <div className="flex items-center gap-1 flex-wrap">
                <p className="typography-body-sm text-monochrome-500 text-nowrap">
                  Education:
                </p>
                <p className="typography-body-sm text-monochrome-900">
                  {selectedPersona.education || "-"}
                </p>
              </div>
              <div className="flex items-center gap-1 flex-wrap">
                <p className="typography-body-sm text-monochrome-500 text-nowrap">
                  Marital status:
                </p>
                <p className="typography-body-sm text-monochrome-900">
                  {selectedPersona.marital_status || "-"}
                </p>
              </div>
              <div className="flex items-center gap-1 flex-wrap">
                <p className="typography-body-sm text-monochrome-500 text-nowrap">
                  Family size:
                </p>
                <p className="typography-body-sm text-monochrome-900">
                  {selectedPersona.family_size || "-"}
                </p>
              </div>
              <div className="flex items-center gap-1 flex-wrap">
                <p className="typography-body-sm text-monochrome-500 text-nowrap">
                  Included Locations:
                </p>
                <p className="typography-body-sm text-monochrome-900">
                  {selectedPersona.included_locations &&
                  selectedPersona.included_locations.length > 0
                    ? selectedPersona.included_locations
                        .map((item) => `${item.country}, ${item.city_name}`)
                        .join("; ")
                    : "-"}
                </p>
              </div>
              <div className="flex items-center gap-1 flex-wrap">
                <p className="typography-body-sm text-monochrome-500 text-nowrap">
                  Excluded Locations:
                </p>
                <p className="typography-body-sm text-monochrome-900">
                  {selectedPersona.excluded_locations &&
                  selectedPersona.excluded_locations.length > 0
                    ? selectedPersona.excluded_locations
                        .map((item) => `${item.country}, ${item.city_name}`)
                        .join("; ")
                    : "-"}
                </p>
              </div>
            </div>
          </div>
          <div>
            <p className="typography-body-bold-sm text-monochrome-900 mb-1">
              Needs
            </p>
            <p className="typography-body-sm text-monochrome-900">
              {selectedPersona.needs || "-"}
            </p>
          </div>
          <div className="flex flex-col gap-4">
            <div>
              <p className="typography-body-bold-sm text-monochrome-900 mb-1">
                Concerns
              </p>
              <p className="typography-body-sm text-monochrome-900">
                {selectedPersona.concerns || "-"}
              </p>
            </div>
            <div>
              <p className="typography-body-bold-sm text-monochrome-900 mb-1">
                Motivations
              </p>
              <p className="typography-body-sm text-monochrome-900">
                {selectedPersona.motivations || "-"}
              </p>
            </div>
          </div>
        </div>
      </RevWhiteDisclosure>
    );
  }
  return null;
};
